(() => {
  const init = () => document.querySelectorAll('.lp-velcro .r5m__month-bars').forEach(chart => {
    if (chart.dataset.animated || !('IntersectionObserver' in window)) return;
    chart.dataset.animated = 'true';
    const bars = [...chart.querySelectorAll('i')];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      observer.disconnect();
      if (reduced.matches) return;
      bars.forEach((bar, i) => {
        if (typeof bar.animate === 'function') bar.animate([{transform:'scaleX(0)'},{transform:'scaleX(1)'}], {duration:700,delay:i*220,easing:'cubic-bezier(.22,.61,.36,1)',fill:'backwards'});
      });
    }, {threshold:0.65});
    observer.observe(chart);
    reduced.addEventListener('change', () => { if (reduced.matches) bars.forEach(bar => bar.getAnimations().forEach(animation => animation.cancel())); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
